export default {
  desktop: {
    button: {
      size: "14px",
      lineHeight: "normal",
    },
    regular: {
      size: "14px",
      lineHeight: "18px",
    },
    copy: {
      size: "14px",
      lineHeight: "18px",
    },
    label: {
      size: "12px",
      lineHeight: "16px",
    },
    caption: {
      size: "12px",
      lineHeight: "16px",
    },
    tabs: {
      size: "16px",
      lineHeight: "26px",
    },
    tabsVariant: {
      size: "20px",
      lineHeight: "24px",
    },
  },
  tablet: {
    button: {
      size: "14px",
      lineHeight: "25px",
    },
    regular: {
      size: "14px",
      lineHeight: "18px",
    },
    copy: {
      size: "14px",
      lineHeight: "18px",
    },
    label: {
      size: "12px",
      lineHeight: "16px",
    },
    caption: {
      size: "12px",
      lineHeight: "16px",
    },
    tabs: {
      size: "16px",
      lineHeight: "26px",
    },
    tabsVariant: {
      size: "20px",
      lineHeight: "24px",
    },
  },
  mobile: {
    button: {
      size: "14px",
      lineHeight: "18px",
    },
    regular: {
      size: "14px",
      lineHeight: "18px",
    },
    noZoomCopy: {
      size: "16px",
    },
    copy: {
      size: "12px",
      lineHeight: "16px",
    },
    label: {
      size: "12px",
      lineHeight: "16px",
    },
    caption: {
      size: "12px",
      lineHeight: "16px",
    },
    tabs: {
      size: "14px",
      lineHeight: "18px",
    },
    tabsVariant: {
      size: "16px",
      lineHeight: "20px",
    },
  },
};
